var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"x-small":"","color":"error"}},[_vm._v("Zablokowany")])
}
var staticRenderFns = []

export { render, staticRenderFns }